<app-document-subheader/>
<div class="details-content container-fluid h-100">
  <div class="row h-100">
    <div class="col-content d-flex flex-column h-100">
      @if (this.commissionPlanRuleModel$ | async; as commissionPlanRuleModel) {
        <div class="page-container">
          <div class="card card-light w-100">
            <div class="card-body">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-6 col-lg-6">
                    <div class="form-group">
                      <label class="form-title-label" translate>COMMISSION_PLAN_RULE_LBL_NAME</label>
                      <div class="form-title">{{ commissionPlanRuleModel.name }}</div>
                    </div>
                  </div>
                  <div class="col"></div>
                </div>
                <div class="row">
                  <div class="col-6 col-lg-6">
                    @if (commissionType$ | async; as commissionType) {
                      @if (commissionType === 'CompanyCommission') {
                        <div class="form-group row">
                          <label class="col-4 col-form-label-sm" translate>COMMISSION_PLAN_RULE_LBL_PRODUCTLINE_NAME</label>
                          <div class="col">
                            <span class="form-control-plaintext form-control-sm">
                              @if (!!commissionPlanRuleModel.productLineName && !!commissionPlanRuleModel.productLineId) {
                                <app-link-to
                                  [id]="commissionPlanRuleModel.productLineId.toString()"
                                  [label]="commissionPlanRuleModel.productLineName"
                                  [url]="'/Insurance/ProductLines/Details/'"/>
                              } @else {
                                {{ commissionPlanRuleModel.productLineName }}
                              }
                            </span>
                          </div>
                        </div>
                      }
                      @if (commissionType === 'SalesPersonCommission' || commissionType === 'SharedSalesPersonCommission') {
                        <div class="form-group row">
                          <label class="col-4 col-form-label-sm"
                          translate>COMMISSION_PLAN_RULE_LBL_COMMISSION_PLAN_NAME</label>
                          <div class="col">
                            <span class="form-control-plaintext form-control-sm">
                              {{ commissionPlanRuleModel.commissionPlans | commissionPlanExtractName | joinAllArrayValues : ',' }}
                            </span>
                          </div>
                        </div>
                      }
                      @if (commissionType === 'SalesPersonCommission') {
                        <div class="form-group row">
                          <label class="col-4 col-form-label-sm" translate>COMMISSION_PLAN_RULE_LBL_SOURCE</label>
                          <div class="col">
                            <span class="form-control-plaintext form-control-sm">
                              {{ commissionPlanRuleModel.commissionPlanRuleSourceLoc}}
                            </span>
                          </div>
                        </div>
                      }
                    }
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate>COMMISSION_PLAN_RULE_LBL_VALUE</label>
                      <div class="col">
                        <span class="form-control-plaintext form-control-sm">
                          {{ commissionPlanRuleModel.value | showSignValueType: commissionPlanRuleModel.amountType}}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate>COMMISSION_PLAN_RULE_LBL_START_DATE</label>
                      <div class="col">
                        <span class="form-control-plaintext form-control-sm">
                          {{
                          !!commissionPlanRuleModel.startDate
                          ? (commissionPlanRuleModel.startDate | date : 'dd/MM/yyyy')
                          : '-'
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate>COMMISSION_PLAN_RULE_LBL_END_DATE</label>
                      <div class="col">
                        <span class="form-control-plaintext form-control-sm">
                          {{
                          !!commissionPlanRuleModel.endDate
                          ? (commissionPlanRuleModel.endDate | date : 'dd/MM/yyyy')
                          : '-'
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    @if (this.commissionPlanRuleModel$ | async; as commissionPlanRule) {
      <div class="col-comment">
        <app-comment-panel [entityType]="'CommissionPlanRule'"
        [entityId]="commissionPlanRule.id.toString()"></app-comment-panel>
      </div>
    }
  </div>
</div>
